import React from 'react'
import SMS from '../../../component/master-settings/sms-gateway/SMS'

function SMSGateway() {
  return (
    <div className='page-body'>
      <SMS/>
    </div>
  )
}

export default SMSGateway
